var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full",staticStyle:{"position":"relative","height":"344px"},attrs:{"id":"totalinvoiceIndexChart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }